import React from 'react';
import CardCollapsible from 'commons/components/CardCollapsible';

function IncomesSummarySkeleton(): JSX.Element {
  return <CardCollapsible.Skeleton />;
}

export default IncomesSummarySkeleton;
